export class CrushCode{
  public ID:string;
  public Code:string;

}
